export class ChartRenderedEvent {}

export class ChartPagesReadyEvent {}
